<template>
    <div
        class="absolute hidden group-hover:block bg-white p-4 text-left rounded shadow-lg whitespace-nowrap z-10">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">

</script>